import React from 'react'
import PropTypes from 'prop-types'
import { initialsFromParts, formatHandicap } from '../../helpers/player'
import { sharedT } from '../../helpers/i18n'

// Initials avatar + name + H.I. as a fragment: the caller owns the row and its styling.

const PlayerIdentity = ({ name, firstName, lastName, handicapIndex }) => {
  const handicap = formatHandicap(handicapIndex)

  return (
    <>
      <div className="gl-player-av" aria-hidden="true">{initialsFromParts(firstName, lastName, name)}</div>
      <div className="gl-player-info">
        <div className="gl-player-nm">{name}</div>
        {handicap !== null && (
          <div className="gl-player-hi">{sharedT('hi_display', { value: handicap })}</div>
        )}
      </div>
    </>
  )
}

PlayerIdentity.propTypes = {
  name: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  handicapIndex: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
}

export default PlayerIdentity
